module.exports = __webpack_public_path__ + "img/free.d29a2937.png";